import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-section-card',
    templateUrl: './section-card.component.html',
    styleUrls: ['./section-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonicModule, RouterLink, TranslateModule]
})
export class SectionCardComponent {
  @Input() collapsableTitle!: string;
  @Input() collapsableTitleId: number = 0;
  @Input() description: string = '';
  @Input() subTitles: string[] = [];
  @Input() sectionLogo: string = 'git-network-outline';
  @Input() logoColor: string = '';

  get effectiveLogoColor(): string {
    return this.logoColor || '#000000';
  }

  get logoBgColor(): string {
    return this.effectiveLogoColor + '22';
  }
}
